import axios from "axios";

export default async function removeProject(projectName){
    await axios.delete(`/project/${projectName}/delete`)
}